type TextType = {
  children: any
  textColor?: string
}

export const Text = ({ children, textColor = 'text-[#767676]' }: TextType) => {
  return <p className={`font-dm-sans font-regular text-lg ${textColor}`}>{children}</p>
}